// Every browser that logs in needs to send a device identifier that's actually
// its own, not a value shared by every visitor. The auth pages used to send
// the literal string "5b6f83c6c9cbba8f" for every single login regardless of
// user or device - if the backend does any per-device tracking (e.g. gating
// a new/unrecognized device behind "needs admin approval" until someone signs
// off on it, which is what staff accounts appear to hit), every web login was
// indistinguishable from every other one to that check, so accounts could
// collide with whichever device state a completely different user's session
// had already established.
//
// This generates a real per-browser id the first time it's needed and
// persists it in localStorage, so the same browser presents the same id on
// every future login (letting the backend recognize a returning, already
// -approved device) while different browsers/phones get different ids.
const DEVICE_ID_STORAGE_KEY = "uzoneWebDeviceId";

function generateId() {
   if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
   }
   // Fallback for browsers without crypto.randomUUID (older mobile Safari/
   // Chrome). Not cryptographically strong, but only needs to be unique
   // enough to distinguish one browser's device record from another's.
   return "web-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
}

export function getDeviceId() {
   try {
      let id = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
      if (!id) {
         id = generateId();
         localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
      }
      return id;
   } catch (e) {
      // localStorage unavailable (private browsing lockdown, in-app browser
      // restrictions, etc.) - fall back to a per-load id rather than throwing
      // out of the login handler.
      return generateId();
   }
}
